import { type FC } from "react";
import cn from "classnames";

import { TextDotDotDot } from "../../textTruncators/TextTruncators";
import { Tooltip } from "../../common/tooltip";
import { type ExpandableLinksProps, type Link } from "../types";

import ExpandableItems from "../ExpandableItems";
import EmptyState from "./EmptyState/EmptyState";

import styles from "./expandableLinks.module.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const ExpandableLinks: FC<ExpandableLinksProps> = (props) => {
  const handleLinkClick = (id: number) => () => {
    window.open(props.linkFormatter(id));
  };

  const renderLink = ({ id, title }: Link) => (
    <div key={id} role="listitem" className={styles["links-list-item"]} onClick={handleLinkClick(id)}>
      <FontAwesomeIcon className={cn(styles[props.iconName])} icon={props.icon} />
      <Tooltip
        className={styles["tooltip-content"]}
        target={<TextDotDotDot clamp={1}>{title}</TextDotDotDot>}
        content={title}
      />
    </div>
  );

  if (props.isReadOnlyView) {
    const useEmptyState = props.links.length === 0;
    return (
      <div className={styles.readOnlyWrapper}>
        <span>{props.label}</span>
        <div className={styles.readOnlyValue}>
          <div className={styles["expandable-links-root"]}>
            <ExpandableItems isReadOnlyView={useEmptyState} contentClassName={styles["links-list-items"]}>
              {useEmptyState ? props.readOnlyEmptyState : props.links.map(renderLink)}
            </ExpandableItems>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={styles["expandable-links-root"]}>
      <ExpandableItems contentClassName={styles["links-list-items"]} label={props.label}>
        {props.links.length ? props.links.map(renderLink) : <EmptyState label={props.label} />}
      </ExpandableItems>
    </div>
  );
};

export default ExpandableLinks;
